import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 1h10v10H1zm12 0h10v10H13zm-2 12H1v10h10zm2 0h10v10H13z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandPlatformMicrosoftWindows = { render };
export {
  brandPlatformMicrosoftWindows as default,
  render
};
//# sourceMappingURL=brand-platform-microsoft-windows.svg.js.map
